<template>
  <div class="noticeManage">
    <OATable
      :data="data"
      :columns="columns"
      :filterData="filterData"
      @search="handleSearch"
      :loading="loading"
    >
      <div slot="button">
        <OAButton @click="noticeSend">发送通知</OAButton>
      </div>
    </OATable>
    <noticeDetail
      v-if="visible"
      :visible.sync="visible"
      :props="detailValue"
      :isEdit="true"
    ></noticeDetail>
  </div>
</template>
<script>
import notice from "@/services/notice.js";
import OAOperationButton from "@/components/OAOperationButton/OAOperationButton";
import noticeDetail from "./noticeDetail.vue";
import { jump } from "@/common/jump";
import { confirm } from "@/utils/messageBox";
export default {
  name: "noticeManage",
  components: { OAOperationButton, noticeDetail },
  data() {
    return {
      data: [],
      filterData: {
        title: {
          formType: "a-input",
          value: undefined,
          col: 4,
          placeholder: "通知标题"
        },
        sender: {
          formType: "a-input",
          value: undefined,
          col: 4,
          placeholder: "发件人"
        },
        sendStatus: {
          formType: "a-select",
          value: undefined,
          col: 4,
          placeholder: "通知状态",
          code: 158
        },
        sendTime: {
          formType: "a-date-picker",
          type: "daterange",
          value: undefined,
          startPlaceholder: "发送开始日期",
          endPlaceholder: "发送结束日期",
          col: 6
        }
      },
      columns: [
        {
          title: "通知标题",
          key: "title"
        },
        {
          title: "通知状态",
          key: "sendStatus"
        },
        {
          title: "发送人",
          key: "sender"
        },
        {
          title: "发送时间",
          key: "sendTime"
        },
        {
          title: "总发送（人）",
          key: "totalNum"
        },
        {
          title: "已同意（人）",
          key: "readNum"
        },
        {
          title: "未反馈（人）",
          key: "unReadNum"
        },
        {
          title: "操作",
          key: "handle",
          width: 120,
          className: "handle",
          labelClassName: "normal",
          component: {
            name: OAOperationButton,
            props: {
              bind: [
                {
                  text: "查看通知详情",
                  disabled: (scope) => {
                    return scope.row.sendStatus !== "已发送";
                  },
                  click: this.noticeDetail
                },
                {
                  text: "未反馈再次发送",
                  disabled: (scope) => {
                    return (
                      scope.row.unReadNum == 0 ||
                      scope.row.sendStatus === "草稿箱"
                    );
                  },
                  click: this.sendAgain
                },
                {
                  text: "编辑",
                  disabled: (scope) => {
                    return scope.row.sendStatus !== "草稿箱";
                  },
                  click: (scope) => this.noticeSend(scope.row.id)
                },
                {
                  text: "删除",
                  click: this.noticeDelete,
                  jurisdiction: "noticeDelete"
                }
              ]
            }
          }
        }
      ],
      loading: false,
      detailValue: undefined,
      visible: false
    };
  },
  methods: {
    async handleSearch(val) {
      if (val.sendTime) {
        val.startTime = val.sendTime[0];
        val.endTime = val.sendTime[1];
      }
      if (val.hasOwnProperty("sendTime")) {
        delete val.sendTime;
      }
      let res = await notice.getNoticeListBySender(val);
      this.data = res.data.data;
    },
    noticeSend(id) {
      if (id) {
        //编辑
        jump({
          url: "noticeSend",
          query: {
            id
          }
        });
      } else {
        //新增
        jump({
          url: "noticeSend"
        });
      }
    },
    async noticeDetail(scope) {
      //查看详情
      let res = await notice.getDetailsById({ noticeId: scope.row.id });
      this.detailValue = res.data.data;
      this.visible = true;
    },
    async sendAgain(scope) {
      //再次发送
      let res = await confirm(
        `确认再次发送通知？（重新发送前，请刷新列表以获取最新数据）`,
        "未反馈再次发送"
      );
      if (res) {
        await notice.sendNoticeAgain({ noticeId: scope.row.id });
        this.$message.success("通知已发送");
      } else {
        this.$message.warning("操作已取消");
      }
    },
    async noticeDelete(scope) {
      let res = await confirm("确定删除通知？", "删除通知");
      if (res) {
        await notice.deleteNotice({ noticeId: scope.row.id });
        this.$message.success("通知已删除");
        this.handleSearch({});
      } else {
        this.$message.warning("操作已取消");
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/notice/noticeManage.vue